import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminGBPBusinessPaginationApi, ConfirmPayemntGBPApi, ConnectFacebookPageApi, ConnectInstagramPageApi, connectInstagramPortfolioApi, deleteCheckinBusinessApi, disconnectJobberApi, GBPBusinessEnableApi, getCheckinBusinessPaginatedApi, GetDashboardApi, GetGBPApi, GetGBPBusinessApi, GetGBPBusinessDetailsApi, getListGBPPaginatedApi, getPostsPaginatedApi, importGBPApi, IntigrationApi, listManagedBusinessApi, removeIntigrationApi, SubscribeGBPApi, transferAccountApi } from "../../apis/AdminApis/GBPApis";
import { showSnackbar } from "../../slices/SnackbarSlice";
import { IPagination } from "../../apis/AdminApis/AdminDataApi";


// export const AddGBPAction = createAsyncThunk(
//     "business/add-gbp",
//     async (token: string, { rejectWithValue, dispatch }) => {
//         try {
//             const response = await AddGBPApi(token)
//             dispatch(GetGBPAction())
//             return response.data;
//         } catch (error: any) {
//             return rejectWithValue(error.response?.data?.message || error.message);
//         }
//     }
// );



export const GetGBPAction = createAsyncThunk(
    "business/get-gbp",
    async (_, { rejectWithValue }) => {
        try {
            const response = await GetGBPApi()
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const getCheckinBusinessPaginatedAction = createAsyncThunk(
    "business/get-checkin-business-paginated",
    async (payload: IPagination, { rejectWithValue }) => {
        try {
            const response = await getCheckinBusinessPaginatedApi(payload)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const GetGBPBusinessDetailsAction = createAsyncThunk(
    "business/get-gbp-business-details",
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await GetGBPBusinessDetailsApi(id)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
// export const GetListGBPAction = createAsyncThunk(
//     "business/get-gbp-list",
//     async (_, { rejectWithValue }) => {
//         try {
//             const response = await getListGBPApi()
//             return response.data;
//         } catch (error: any) {
//             return rejectWithValue(error.response?.data?.message || error.message);
//         }
//     }
// );
export const GetListGBPPaginatedAction = createAsyncThunk(
    "business/get-gbp-list-paginated",
    async (payload: { page: number, limit: number, keyword: string, email: string[], sort_by?: string, sort_order?: string }, { rejectWithValue }) => {
        try {
            const response = await getListGBPPaginatedApi(payload)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
export const importGBPAction = createAsyncThunk(
    "business/import-gbp",
    async (business_ids: string[], { rejectWithValue, dispatch }) => {
        try {
            const response = await importGBPApi(business_ids);
            if (response?.data?.success === false) {
                dispatch(showSnackbar({ message: response?.data?.message || "Failed to import business", type: "error" }));
            }
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.message || "Failed to import business";
            dispatch(showSnackbar({ message, type: "error" }));
            return rejectWithValue(message);
        }
    }
);

export const GetGBPBusinessAction = createAsyncThunk(
    "business/get-gbp-business",
    async (_, { rejectWithValue }) => {
        try {
            const response = await GetGBPBusinessApi()
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const adminGBPBusinessPaginationAction = createAsyncThunk(
    "business/get-gbp-business-pagination",
    async (payload: IPagination, { rejectWithValue }) => {
        try {
            const response = await adminGBPBusinessPaginationApi(payload)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const GBPBusinessEnableAction = createAsyncThunk(
    "business/gbp-business-enable",
    async (business_id: string, { rejectWithValue }) => {
        try {
            const response = await GBPBusinessEnableApi(business_id)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const SubscribeGBPAction = createAsyncThunk(
    "addon/checkin-purchase",
    async (id: string, { rejectWithValue, dispatch }) => {
        try {
            const response = await SubscribeGBPApi(id)
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.message || "Failed to purchase check-in subscription";
            dispatch(showSnackbar({ message, type: "error" }));
            return rejectWithValue(message);
        }
    }
);


export const ConfirmPaymentGBPAction = createAsyncThunk(
    "addon/confirm-purchase",
    async (payload: any, { rejectWithValue, dispatch }) => {
        try {
            const response = await ConfirmPayemntGBPApi(payload)
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.message || "Failed to confirm purchase";
            dispatch(showSnackbar({ message, type: "error" }));
            return rejectWithValue(message);
        }
    }
);


export const GetDashboardAction = createAsyncThunk(
    "business/dashboard",
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await GetDashboardApi(id)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const getPostsPaginatedAction = createAsyncThunk(
    "business/get-posts-paginated",
    async (payload: {
        checkin_id: string,
        page: number,
        limit: number,
        keyword?: string,
        status?: string,
        employee_id?: string,
        platform?: string,
        date_from?: string,
        date_to?: string,
        sort_by?: string,
        sort_order?: string
    }, { rejectWithValue }) => {
        try {
            const response = await getPostsPaginatedApi(payload)
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
export const ConnectFacebookPageAction = createAsyncThunk("/connect-facebook-page", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await ConnectFacebookPageApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to add integration", type: "error" }));
        return rejectWithValue(error.response?.data?.message || error.message);
    }
})

export const ConnectInstagramPageAction = createAsyncThunk("/connect-instagram-page", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await ConnectInstagramPageApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to add integration", type: "error" }));
        return rejectWithValue(error.response?.data?.message || error.message);
    }
})

export const connectInstagramPortfolioAction = createAsyncThunk("/connect-instagram-portfolio", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await connectInstagramPortfolioApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to add integration", type: "error" }));
        return rejectWithValue(error.response?.data?.message || error.message);
    }
})

export const IntigrationAction = createAsyncThunk(
    "business/intigration",
    async (payload: any, { rejectWithValue, dispatch }) => {
        try {
            const response = await IntigrationApi(payload)
            dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to add integration", type: "error" }));
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const removeIntigrationAction = createAsyncThunk("remove/intigration", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await removeIntigrationApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to remove integration", type: "error" }));
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

export const transferAccountAction = createAsyncThunk("transfer/account", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await transferAccountApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
        return response.data;
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message || "failed to remove integration", type: "error" }));
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

export const listManagedBusinessAction = createAsyncThunk("list/managed-business", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await listManagedBusinessApi()
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

export const deleteCheckinBusinessAction = createAsyncThunk(
    "business/delete-checkin-business",
    async (payload: { business_id: string, force?: boolean }, { rejectWithValue, dispatch }) => {
        try {
            const response = await deleteCheckinBusinessApi(payload);
            if (payload?.force) {
                dispatch(showSnackbar({ message: response?.data?.message || "Business deleted successfully", type: "success" }));
            }
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message || "Failed to delete business", type: "error" }));
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
export const disconnectJobberAction = createAsyncThunk(
    "jobber/disconnect",
    async (payload: { businessId: string }, { rejectWithValue, dispatch }) => {
        try {
            const response = await disconnectJobberApi(payload);
            dispatch(
                showSnackbar({ message: response?.data?.message, type: "success" })
            );
            return response.data;
        } catch (error: any) {
            dispatch(
                showSnackbar({
                    message:
                        error?.response?.data?.message || "failed to remove integration",
                    type: "error",
                })
            );
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
